import type { PopoverAnchorProps } from "@radix-ui/react-popover";
import { PopoverAnchor } from "components/ui/Popover";

export default function SelectedIndicatorPopoverAnchor({ children, ...props }: PopoverAnchorProps) {
  return (
    <PopoverAnchor asChild={true} {...props}>
      {children}
    </PopoverAnchor>
  );
}
